import { render, staticRenderFns } from "./PlanSelection.vue?vue&type=template&id=649816d1"
import script from "./PlanSelection.vue?vue&type=script&lang=js"
export * from "./PlanSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports